import React, { useEffect, useState, useCallback, useRef } from 'react';
import './Reports.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faEuroSign } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getColorForStatus, evaluateAnswers, EvaluationResult, evaluateAnswersSC } from '../evaluationHelper';

const config=require( '../../config.js');

function Reports() {
    const translations = {
        english: {
            turnover: 'Turnover',
            topic: 'EU Taxonomy alignment for Clean Energy Activities',
            capEx: 'CapEx',
            opEx: 'OpEx',
            numberOfActivities: '# of Activities',
            reportConfess: 'Report on Taxonomy alignment',
            forCompanyName: 'For',
            disclaimer: 'Disclaimer: The evaluation is based on the information provided in the tool. No verifications were conducted.',
            totalNumberOfActivities: 'Total Number of Activities:',
            totalTurnover: 'Total Turnover: ',
            totalCapEx: 'Total CapEx: ',
            totalOpEx: 'Total OpEx: ',
            aligned: 'Aligned',
            notAlignedButEligible: 'Not aligned but eligible',
            notEligible: 'Not eligible',
            activitiesInDetail: 'Activities in Detail',
            mssTitle: 'Minimum Social Safeguards',
            mssMet: 'Your company fulfilled the Minimum Social Safeguards requirements.',
            mssNotMet: 'Your company does not fulfil the Minimum Social Safeguards requirements.',
            legend: 'Legend',
            criteriaMet: 'Criteria met',
            criteriaNotMet: 'Criteria not met',
            criteriaNotAssessable: 'Criteria not assessable',
            reportCreated: 'Report already created, delete the old one to send a new one',
            reportMissingAssessment: 'No assessments submitted',
            reportNoMSS: 'Please complete the assessment for the Minimum Social Safeguards for the financial year before creating the report.',
            reportNotEnded: 'Please complete the assessments before creating the report.',
            reportNewCreated: 'Report created. Attention, the report has not yet been sent to the expert. To do this, go to the Report section and submit the report via the paperplane icon',
        },
        german: {
            turnover: 'Umsatz',
            topic: 'EU-Taxonomie-Ausrichtung für saubere Energieaktivitäten',
            capEx: 'CapEx (Investitionskosten)',
            opEx: 'OpEx (Betriebskosten)',
            numberOfActivities: '# der Aktivitäten',
            reportConfess: 'Bericht: Taxonomiekonformität',
            forCompanyName: 'Für',
            disclaimer: 'Haftungsausschluss: Die Bewertung basiert auf den im Tool bereitgestellten Informationen. Es wurden keine Überprüfungen durchgeführt.',
            totalNumberOfActivities: 'Anzahl aller Unternehmensaktivitäten:',
            totalTurnover: 'Umsatz (gesamt): ',
            totalCapEx: 'CapEx (gesamt): ',
            totalOpEx: 'OpEx (gesamt): ',
            aligned: 'Taxonomiekonform',
            notAlignedButEligible: 'Taxonomiefähig',
            notEligible: 'Nicht Taxonomiefähig',
            activitiesInDetail: 'Detaillierte Auswertung der Aktivitäten',
            legend: 'Legende',
            criteriaMet: 'Kriterium erfüllt',
            criteriaNotMet: 'Kriterium nicht erfüllt',
            criteriaNotAssessable: 'Kriterien nicht beurteilbar',
            mssTitle: 'Mindestsoziale Schutzmaßnahmen',
            mssMet: 'Ihr Unternehmen hat die Anforderungen an die Mindestsozialen Schutzmaßnahmen erfüllt.',
            mssNotMet: 'Ihr Unternehmen erfüllt die Anforderungen an die Mindestsozialen Schutzmaßnahmen nicht.',
            reportCreated: 'Bericht bereits erstellt, löschen Sie den alten, um einen neuen zu senden',
            reportMissingAssessment: 'Keine Bewertung gesendet',
            reportNoMSS: 'Bitte füllen Sie die Bewertung für die Sozialer Mindeststandard für das Geschäftsjahr aus, bevor Sie den Bericht erstellen.',
            reportNotEnded: 'Bitte führen Sie die Bewertungen durch, bevor Sie den Bericht erstellen.',
            reportNewCreated: 'Bericht erfolgreich erstellt. Achtung, der Bericht ist noch nicht an den Experten gesendet worden. Gehen Sie dazu in den Bereich "Report" und reichen Sie den Bericht über das Papierflugzeug-Symbol ein.',
        },
        czech: {
            turnover: 'Obchodní obrat',
            topic: 'Srovnání s taxonomií EU pro činnosti v oblasti čisté energie',
            capEx: 'CapEx (Investiční náklady)',
            opEx: 'OpEx (Provozní náklady)',
            numberOfActivities: 'Počet aktivit',
            reportConfess: 'Zpráva: CONFESS',
            forCompanyName: 'Pro',
            disclaimer: 'Disclaimer: Hodnocení je založeno na informacích poskytnutých v nástroji. Nebyla provedena žádná ověření.',
            totalNumberOfActivities: 'Celkový počet aktivit:',
            totalTurnover: 'Celkový obrat: ',
            totalCapEx: 'Celkové kapitálové výdaje: ',
            totalOpEx: 'Celkové provozní výdaje: ',
            aligned: 'Srovnané',
            notAlignedButEligible: 'Nesrovnané, ale způsobilé',
            notEligible: 'Nezpůsobilé',
            activitiesInDetail: 'Aktivity podrobně',
            legend: 'Legenda',
            criteriaMet: 'Kritéria splněna',
            criteriaNotMet: 'Kritéria nesplněna',
            criteriaNotAssessable: 'Kritéria nelze posoudit',
            mssTitle: 'Minimální sociální záruky',
            mssMet: 'Vaše společnost splnila požadavky na minimální sociální záruky.',
            mssNotMet: 'Vaše společnost nesplňuje požadavky na minimální sociální záruky.',
            reportCreated: 'Sestavu již vytvořenou, odstraňte starou a odešlete novou',
            reportMissingAssessment: 'Nebylo odesláno žádné hodnocení',
            reportNoMSS: 'Nebyla odeslána žádná MSS',
            reportNotEnded: 'Před vytvořením zprávy prosím dokončete hodnocení.',
            reportNewCreated: 'Zpráva vytvořena. Pozor, zpráva ještě nebyla odeslána expertovi. Chcete-li tak učinit, přejděte do sekce Zpráva a odešlete zprávu pomocí ikony papírového letadla.',
        },
        italian: {
            turnover: 'Fatturato',
            topic: 'Allineamento alla tassonomia UE per le attività di energia pulita',
            capEx: 'CapEx',
            opEx: 'OpEx',
            numberOfActivities: 'Numero di attività',
            reportConfess: 'Report sull’allineamento Tassonomico',
            forCompanyName: 'Per',
            disclaimer: 'Disclaimer: La valutazione si basa sulle informazioni fornite nello strumento. Non sono state effettuate verifiche.',
            totalNumberOfActivities: 'Numero totale di attività:',
            totalTurnover: 'Fatturato totale: ',
            totalCapEx: 'CapEx totale: ',
            totalOpEx: 'OpEx totale: ',
            aligned: 'Allineato',
            notAlignedButEligible: 'Non allineato ma elegibile',
            notEligible: 'Non elegibile',
            activitiesInDetail: 'Attività nel dettaglio',
            legend: 'Legenda',
            criteriaMet: 'Criterio soddisfatto',
            criteriaNotMet: 'Criterio non soddisfatto',
            criteriaNotAssessable: 'Criterio non valutabile',
            mssTitle: 'Criteri Sociali Minimi di Salvaguardia',
            mssMet: 'La tua azienda ha soddisfatto i Criteri Sociali Minimi di Salvaguardia.',
            mssNotMet: 'la tua azienda non soddisfa i Criteri Sociali Minimi di Salvaguardia.',
            reportCreated: 'Report già creato, cancellare il vecchio per inviarne uno nuovo',
            reportMissingAssessment: 'Nessun assessment inviato',
            reportNoMSS: 'Nessun MSS inviato',
            reportNotEnded: 'Si prega di completare le valutazioni prima di creare il report.',
            reportNewCreated: 'Rapporto creato con successo. Attenzione, il rapporto non è ancora stato inviato all\'esperto. A tal fine, accedere alla sezione Reports e inviare il rapporto tramite l\'icona dell\'aeroplanino.',
        },
      };

    const [results, setResults] = useState([]);
    const [result, setResult] = useState([]);
    const [fiscalYear, setFiscalYear] = useState();
    const [totalTurnover, setTotalTurnover] = useState(0);
    const [totalCapex, setTotalCapex] = useState(0);
    const [totalOpex, setTotalOpex] = useState(0);
    const [Dashopop, setDashopop] = useState(false);
    const [users, setUsers] = useState([]);
    const [currency, setCurrency] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const navigate = useNavigate();

    const [reloaddash, setreloaddash] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const reportYear = searchParams.get('reportYear');
    
    const reportUserId = searchParams.get('userId');
    
    const SaveLanguage = useCallback((language) => {
        if (currentLanguage !== language) {
            localStorage.setItem('language', language);
            setCurrentLanguage(language); // Update the state
        }
    }, [currentLanguage]);

    useEffect(() => {
        if (!localStorage.getItem('language')) {
            localStorage.setItem('language', 'english');
            setCurrentLanguage('english');
        }
    }, []);

    useEffect(() => {
        setCurrency(users.currency);
    }, [users]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(config.env.API_BASE_URL+'/api/users/' + (reportUserId != null ? reportUserId : 'me'), {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        if(reportUserId == null) {
                            localStorage.setItem('user', JSON.stringify(data));
                        }
                        setUsers(data);
                    } else {
                        console.error('No matching user found');
                    }
                } else {
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, [reloaddash]);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                const response = await fetch(config.env.API_BASE_URL+`/api/dashboard` +  (reportUserId != null ? '/' + reportUserId : ''), {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    if(data.users && data.users.length > 0) {
                        if(reportUserId == null)
                            localStorage.setItem('user', JSON.stringify(data.users[0]));
                        
                    }
                    setResults(data);
                    setResult(data);
                    setTimeout(() => {
                        setUsers(data.users[0]);
                    }, 100);
                    
                    if(data.results && data.results.length > 0) {
                        if(reportYear != null && reportYear != undefined) {
                            setFiscalYear(reportYear);
                        } else {
                            setDashopop(true);
                        }
                    } else {
                        window.location.href = "/landing";
                        alert("No Assesment completed");
                    }
                } else {
                    console.error('Failed to fetch results');
                }
            } catch (error) {
                console.error('Error fetching results:', error);
            }
        };
        fetchResults();
    }, []);

    const DashResult = result.results || [];
    //const TotalActivity = getFilteredDashResult(DashResult, fiscalYear).length;

    const [alignedValue, setAlignedValue] = useState([]);
    const [notAlignedButEligibleValue, setNotAlignedButEligibleValue] = useState([]);
    const [NotEligible, setNotEligible] = useState([]);

    const prevAlignedValueRef = useRef([]);
    const prevNotAlignedButEligibleValueRef = useRef([]);
    const prevNotEligibleRef = useRef([]);

    useEffect(() => {
        prevAlignedValueRef.current = alignedValue;
        prevNotAlignedButEligibleValueRef.current = notAlignedButEligibleValue;
        prevNotEligibleRef.current = NotEligible;
    }, [alignedValue, notAlignedButEligibleValue, NotEligible]);

    const FinalAligned = prevAlignedValueRef.current;
    const FinalNotAligned = prevNotAlignedButEligibleValueRef.current;
    const FineaNotEligible = prevNotEligibleRef.current;

    const financialData = users?.financialData ?? [];
    const yearData = financialData.find(data => Number(data.fiscalYear) === Number(fiscalYear)) || {};
    const TotalActivity = yearData.totalActivity;

    // Turnover
    const AlignedturnoverAnswers = FinalAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'Turnover')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const AlignedTurnover = AlignedturnoverAnswers.reduce((acc, val) => acc + val, 0);

    const NotAlignedturnoverAnswers = FinalNotAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'Turnover')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const NotAlignedTurnover = NotAlignedturnoverAnswers.reduce((acc, val) => acc + val, 0);

    const NotEligibleTurnover = yearData.totalTurnover - AlignedTurnover - NotAlignedTurnover;

    // CapEx
    const AlignedcapexAnswers = FinalAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'CapEx')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const AlignedCapEx = AlignedcapexAnswers.reduce((acc, val) => acc + val, 0);


    const NotAlignedcapexAnswers = FinalNotAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'CapEx')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const NotAlignedCapEx = NotAlignedcapexAnswers.reduce((acc, val) => acc + val, 0);

    const NotEligibleCapEx = yearData.totalCapex - AlignedCapEx - NotAlignedCapEx;

    // OpEx
    const AlignedopexAnswers = FinalAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'OpEx')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const AlignedOpEx = AlignedopexAnswers.reduce((acc, val) => acc + val, 0);

    const NotAlignedopexAnswers = FinalNotAligned.map(item =>
        item.answers.find(answer => answer.questionCategory === 'OpEx')
    ).map(answer => answer ? parseFloat(answer.answer[0]) : 0);
    const NotAlignedOpEx = NotAlignedopexAnswers.reduce((acc, val) => acc + val, 0);

    const NotEligibleOpEx = yearData.totalOpex - AlignedOpEx - NotAlignedOpEx;

    const ChartDetails = [
        {
            title: translations[currentLanguage].turnover,
            topic: translations[currentLanguage].topic,
            alignedValue: AlignedTurnover,
            notAlignedButEligibleValue: NotAlignedTurnover,
            notEligibleValue: NotEligibleTurnover,
            showCurrency: true,
        },
        {
            title: translations[currentLanguage].capEx,
            topic: translations[currentLanguage].topic,
            alignedValue: AlignedCapEx,
            notAlignedButEligibleValue: NotAlignedCapEx,
            notEligibleValue: NotEligibleCapEx,
            showCurrency: true,
        },
        {
            title: translations[currentLanguage].opEx,
            topic: translations[currentLanguage].topic,
            alignedValue: AlignedOpEx,
            notAlignedButEligibleValue: NotAlignedOpEx,
            notEligibleValue: NotEligibleOpEx,
            showCurrency: true,
        },
        {
            title: translations[currentLanguage].numberOfActivities,
            topic: translations[currentLanguage].topic,
            alignedValue: FinalAligned.length,
            notAlignedButEligibleValue: FinalNotAligned.length,
            notEligibleValue: yearData.totalActivity - FinalAligned.length - FinalNotAligned.length,
            showCurrency: false,
        }
    ];

    const handleCreateReport = async () => {
        const reportData = {
            fiscalYear: fiscalYear,
        };
        try {
            const response = await fetch(config.env.API_BASE_URL+'/api/reports/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(reportData)
            });

            if (response.ok) {
                alert(translations[currentLanguage].reportNewCreated);
            } else {
                const errorData = await response.json();
                if(errorData.message === "100")
                    alert(translations[currentLanguage].reportCreated);
                else if(errorData.message === "101" || errorData.message === "102") {
                    alert(translations[currentLanguage].reportMissingAssessment);
                    window.location.href = "/landing";
                } 
                else if(errorData.message === "103")
                    alert(translations[currentLanguage].reportNoMSS);
                else if(errorData.message === "104")
                    alert(translations[currentLanguage].reportNotEnded);
                else
                    alert(`Failed to create report: ${errorData.message}`);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while saving the report.');
        }
    };

    const rslt = getMSSResult(DashResult, fiscalYear);
    const mssMet = rslt.length > 0 ? evaluateAnswers(rslt[0].answers, 'Blank') : EvaluationResult.NOT_ASSESSABLE;

    const GoBack = () => {
        window.history.back();
    }

    return (
        <>
        <div style={{cursor:"pointer", left: "30px", position: "absolute", top: "55px"}} onClick={() => GoBack()}>
                          <FontAwesomeIcon icon={faArrowLeftLong} />
                          <span style={{ marginLeft: "10px" }}>Back</span>
                        </div>
        <div className='d-flex justify-content-center mt-5'>
            <section className='reports-main'>
                { reportYear == null && 
                <div className='d-flex container justify-content-end'>
                    <button className='btn-create-report mb-3' onClick={() => handleCreateReport()}>
                        Create Report
                    </button>
                </div>
}
                <div className="card card-reports">
                    <div className="card-header text-start">
                        <h3 className='fw-light'>{translations[currentLanguage].reportConfess}</h3>
                        <p>{translations[currentLanguage].forCompanyName} {users.companyName} ({fiscalYear})</p>
                        </div>
                    <div className="card-body text-start">
                        <p className="card-title">
                            <i>{translations[currentLanguage].disclaimer}</i>
                        </p>
                        <p className="card-title mt-3">{translations[currentLanguage].totalNumberOfActivities} <span>{TotalActivity}</span></p>
                        <p className="mt-3">
                            {translations[currentLanguage].totalTurnover}{yearData.totalTurnover} {currency} <br />
                            {translations[currentLanguage].totalCapEx}{yearData.totalCapex} {currency} <br />
                            {translations[currentLanguage].totalOpEx}{yearData.totalOpex} {currency}
                        </p>
                    </div>
                </div>

                <section className='section-card'>
                    {ChartDetails.map((value, index) => {

                        // Calculate percentages
                        const total = value.alignedValue + value.notAlignedButEligibleValue + value.notEligibleValue;

                        const alignedPercentage = (value.alignedValue / total) * 100;
                        const notAlignedButEligiblePercentage = (value.notAlignedButEligibleValue / total) * 100;
                        const notEligiblePercentage = (value.notEligibleValue / total) * 100;

                        return (
                            <div key={index} className='card-main'>
                                <div className="card card-stats">
                                    <div className="card-body text-start">
                                        <h4>{value.title}</h4>
                                        <p className="card-title">{value.topic}</p>

                                        <div className="circle m-4">
                                            <div className="circle-progress"
                                                style={{
                                                    background: `conic-gradient(#2B522F 0% ${alignedPercentage}%,  #34A474 ${alignedPercentage}% ${alignedPercentage + notAlignedButEligiblePercentage}%, #A4A5A7 ${alignedPercentage + notAlignedButEligiblePercentage}% 100%)`
                                                }}>
                                            </div>
                                        </div>

                                        <div className='row d-flex flex-column justify-content-between align-items-center'>
                                            <div className='col d-flex justify-content-between'>
                                                <p><span className='dark-dot'></span>{translations[currentLanguage].aligned}</p>
                                                <p>{value.alignedValue} {value.showCurrency ? currency : ''} ({alignedPercentage.toFixed(1)}%)</p>
                                            </div>
                                            <div className='col d-flex justify-content-between'>
                                                <p><span className='green-dot'></span>{translations[currentLanguage].notAlignedButEligible}</p>
                                                <p>{value.notAlignedButEligibleValue} {value.showCurrency ? currency : ''} ({notAlignedButEligiblePercentage.toFixed(1)}%)</p>
                                            </div>
                                            <div className='col d-flex justify-content-between'>
                                                <p><span className='grey-dot'></span>{translations[currentLanguage].notEligible}</p>
                                                <p>{value.notEligibleValue} {value.showCurrency ? currency : ''} ({notEligiblePercentage.toFixed(1)}%)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </section>

                <div className="card card-reports mt-5">
                    <div className="card-header text-start">
                        <h3 className='fw-light'>{translations[currentLanguage].mssTitle}</h3>
                    </div>
                    <div className="card-body text-start">
                            <div className='d-flex mx-3 mt-2 justify-content-between'>
                                <p>{mssMet === EvaluationResult.CRITERIA_MET ? translations[currentLanguage].mssMet : translations[currentLanguage].mssNotMet}</p>
                                <span className={getColorForStatus(mssMet)}></span>
                            </div>
                    </div>
                </div>

                <div className="card card-reports mt-5">
                    <div className="card-header text-start">
                        <h3 className='fw-light'>{translations[currentLanguage].activitiesInDetail}</h3>
                    </div>
                    <div className="card-body text-start">
                        <p className="card-title">
                            <i>{translations[currentLanguage].disclaimer}</i>
                        </p>
                        <p>{translations[currentLanguage].legend}</p>
                        <div className='col'>
                            <p className="mt-3 d-flex align-items-center"><span className='green-dot'></span>{translations[currentLanguage].criteriaMet}</p>
                            <p className="mt-3 d-flex align-items-center"><span className='orange-dot'></span>{translations[currentLanguage].criteriaNotMet}</p>
                            <p className="mt-3 d-flex align-items-center"><span className='grey-dot'></span>{translations[currentLanguage].criteriaNotAssessable}</p>
                        </div>
                    </div>
                </div>

                {<DashActivity currentLanguage={currentLanguage} DashResult={DashResult} alignedValue={alignedValue} notAlignedButEligibleValue={notAlignedButEligibleValue} NotEligible={NotEligible} fiscalYear={fiscalYear} />}

                {Dashopop && <DashboardPop DashResult={DashResult} setreloaddash={setreloaddash} setResults={setResults} totalTurnover={totalTurnover} totalCapex={totalCapex} totalOpex={totalOpex} TotalActivity={TotalActivity} setDashopop={setDashopop} users={users} fiscalYear={fiscalYear} setFiscalYear={setFiscalYear} setUsers={setUsers} />}

            </section>
        </div>
        </>
    );
}


export default Reports;


const getFilteredDashResult = (DashResult, fiscalYear) => {
    if (!Array.isArray(DashResult)) {
        return [];
    }

    return DashResult.filter(value => {
        if (value.isMSS === false || value.isMSS == null) {
            const filteredAnswers = Array.isArray(value?.answers) ? value.answers.filter(answer => answer.questionType !== "Blank") : [];
            const FiscalYear = filteredAnswers.filter(answer => answer.questionCategory === 'Fiscal Year');
            return FiscalYear.some(answer => Number(answer.answer) === Number(fiscalYear));
        }
        return false;
    });
}

const getMSSResult = (DashResult, fiscalYear) => {
    if (!Array.isArray(DashResult)) {
        return [];
    }

    return DashResult.filter(value => {
        if (value.isMSS === true) {
            const filteredAnswers = Array.isArray(value?.answers) ? value.answers.filter(answer => answer.questionType !== "Blank") : [];
            const FiscalYear = filteredAnswers.filter(answer => answer.questionCategory === 'Fiscal Year');
            return FiscalYear.some(answer => Number(answer.answer) === Number(fiscalYear));
        }
        return false;
    });
}

const sumValuesByCategory = (filteredResults, category) => {
    if (!Array.isArray(filteredResults) || typeof category !== 'string') {
        return 0;
    }

    return filteredResults.reduce((total, value) => {
        const answer = value.answers.find(a => a.questionCategory === category);
        const valueAmount = answer ? Number(answer.answer[0]) : 0;
        return total + valueAmount;
    }, 0);
}

const DashboardPop = ({ DashResult, setDashopop, users, setResults, setreloaddash, setFiscalYear, setUsers }) => {
    const [turnover, setTurnover] = useState('');
    const [selectedYear, setSelectedYear] = useState();
    const [capex, setCapex] = useState('');
    const [opex, setOpex] = useState('');
    const [activity, setActivity] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const [reportYears, setReportYears] = useState([]);

    useEffect(() => {
        const fetchYears = async () => {
          const response = await fetch(
            config.env.API_BASE_URL + `/api/reports/years`,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
    
          if (response.ok) {
            const data = await response.json();
            setReportYears(data);
          }
        };
    
        fetchYears();
      }, []);

    const SaveLanguage = useCallback((language) => {
        if (currentLanguage !== language) {
            localStorage.setItem('language', language);
            setCurrentLanguage(language);
        }
    }, [currentLanguage]);

    useEffect(() => {
        if (!localStorage.getItem('language')) {
            localStorage.setItem('language', 'english');
            setCurrentLanguage('english');
        }
    }, []);

    useEffect(() => {
        if (users) {
            const financialData = users?.financialData ?? [];
            const yearData = financialData.find(data => Number(data.fiscalYear) === Number(selectedYear)) || {};

            if (yearData && yearData.totalTurnover && yearData.totalCapex && yearData.totalOpex && yearData.totalActivity) {
                setTurnover(yearData.totalTurnover);
                setCapex(yearData.totalCapex);
                setOpex(yearData.totalOpex); 
                setActivity(yearData.totalActivity);
            } else {
                const totalActivitiesFiltered = getFilteredDashResult(DashResult, selectedYear);
                const totalOpExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "OpEx");
                const totalCapExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "CapEx");
                const totalTurnoverFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "Turnover");

                setTurnover(totalTurnoverFromSubmissions);
                setCapex(totalCapExFromSubmissions);
                setOpex(totalOpExFromSubmissions);
                setActivity(totalActivitiesFiltered.length);
            }          
        }
    }, [users, selectedYear]);

    useEffect(() => {
        const fiscalYears = getUniqueFiscalYears();
        if (fiscalYears.length > 0) {
            setSelectedYear(fiscalYears[0]); // Set to the first year in the list
        }

        // Update default data based on selected year
        if (users) {
            const financialData = users?.financialData ?? [];
            const yearData = financialData.find(data => Number(data.fiscalYear) === Number(selectedYear)) || {};

            if (yearData && yearData.totalTurnover && yearData.totalCapex && yearData.totalOpex && yearData.totalActivity) {
                setTurnover(yearData.totalTurnover);
                setCapex(yearData.totalCapex);
                setOpex(yearData.totalOpex); 
                setActivity(yearData.totalActivity);
            } else {
                const totalActivitiesFiltered = getFilteredDashResult(DashResult, selectedYear);
                const totalOpExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "OpEx");
                const totalCapExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "CapEx");
                const totalTurnoverFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "Turnover");

                setTurnover(totalTurnoverFromSubmissions);
                setCapex(totalCapExFromSubmissions);
                setOpex(totalOpExFromSubmissions);
                setActivity(totalActivitiesFiltered.length);
            }          
        }
    }, [DashResult, reportYears]);

    const navigate = useNavigate();

    const closeThePop = () => {
        setDashopop(false);
    };

    const GoHome = () => {
        navigate('/landing');
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        let updatedData;

        if (selectedYear === undefined) {
            const years = getUniqueFiscalYears();
            if (years.length > 0) {
                setSelectedYear(years[0]);
            }
        }
        setFiscalYear(selectedYear);

        if (selectedYear) {
            updatedData = {
                financialData: {
                    fiscalYear: parseFloat(selectedYear),
                    totalTurnover: parseFloat(turnover),
                    totalCapex: parseFloat(capex),
                    totalOpex: parseFloat(opex),
                    totalActivity: parseFloat(activity)
                }
            };
        }

        const messages = content[currentLanguage].errorMessages;
        let hasError = false;

        const totalActivitiesFiltered = getFilteredDashResult(DashResult, selectedYear);
        const totalOpExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "OpEx");
        const totalCapExFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "CapEx");
        const totalTurnoverFromSubmissions = sumValuesByCategory(totalActivitiesFiltered, "Turnover");

        if (selectedYear === undefined || selectedYear.length === 0) {
            toast.error(messages.yearError, {
                position: 'top-center',
                autoClose: 3000,
                theme: 'light',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
            hasError = true;
        }

        if (parseFloat(turnover) < totalTurnoverFromSubmissions) {
            toast.error(messages.turnoverError.replace('{currentValue}', totalTurnoverFromSubmissions), {
                position: 'top-center',
                autoClose: 3000,
                theme: 'light',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
            hasError = true;
        }
        if (parseFloat(capex) < totalCapExFromSubmissions) {
            toast.error(messages.capexError.replace('{currentValue}', totalCapExFromSubmissions), {
                position: 'top-center',
                autoClose: 3000,
                theme: 'light',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
            hasError = true;
        }
        if (parseFloat(opex) < totalOpExFromSubmissions) {
            toast.error(messages.opexError.replace('{currentValue}', totalOpExFromSubmissions), {
                position: 'top-center',
                autoClose: 3000,
                theme: 'light',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
            hasError = true;
        }
        if (parseFloat(activity) < totalActivitiesFiltered.length) {
            toast.error(messages.activityError.replace('{currentValue}', totalActivitiesFiltered.length), {
                position: 'top-center',
                autoClose: 3000,
                theme: 'light',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
            hasError = true;
        }

        if (hasError || updatedData === undefined) {
            return; // Prevent form submission
        }

        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${users.id}/financial-data`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(updatedData),
            });

            if (response.ok) {
                const updatedUser = await response.json();
                setUsers(updatedUser);
                setResults(updatedUser);
                setDashopop(false);
                setreloaddash(true);
            } else {
                console.error('Failed to update data');
            }
        } catch (error) {
            console.error('Error updating data:', error);
        }
    };

    const content = {
        english: {
            heading: 'Update Total Turnover, CapEx, OpEx',
            paragraphs: [
                'Reporting in accordance with the EU taxonomy indicates the proportion of taxonomy eligible and taxonomy aligned economic activities.',
                'In order to determine their monetary value, the share of taxonomy eligible and taxonomy-aligned activities in turnover, CapEx and OpEx is calculated and reported. To calculate this, we need to know your total turnover, CapEx and OpEx of the fiscal year you want to evaluate. We also need to know the total number of economic activities your company performed in that year.',
                'If you do not know and cannot collect the exact total financials, please estimate:',
            ],
            labels: {
                fiscalYear: "Fiscal year:",
                turnover: 'Total Turnover',
                capex: 'Total Capex',
                opex: 'Total OpEx',
                totalActivities: 'Total Activities',
                cancel: 'Cancel',
                submit: 'Submit',
            },
            errorMessages: {
                yearError: 'Please select a fiscal year.',
                turnoverError: 'The entered turnover amount is lower than the current value of Total Turnover of the selected year: {currentValue}.',
                capexError: 'The entered Capex amount is lower than the current value of Total Capex of the selected year: {currentValue}.',
                opexError: 'The entered OpEx amount is lower than the current value of Total OpEx of the selected year: {currentValue}.',
                activityError: 'The activities amount you entered is less than the total number of activities submitted for the selected year: {currentValue}.',
            }
        },
        german: {
            heading: 'Gesamtumsatz, CapEx, OpEx aktualisieren',
            paragraphs: [
                'Die Berichterstattung gemäß der EU-Taxonomie gibt den Anteil der taxonomie-fähigen und taxonomie-konformen Wirtschaftstätigkeiten an.',
                'Um deren monetären Wert zu bestimmen, wird der Anteil der taxonomie-fähigen und taxonomie-konformen Aktivitäten an Umsatz, den Investitionsausgaben (CapEx) und den Betriebsausgaben (OpEx) berechnet und berichtet. Zur Berechnung benötigen wir Ihren gesamten Umsatz, CapEx und OpEx für das Geschäftsjahr, das Sie bewerten möchten. Wir müssen auch die Gesamtzahl der wirtschaftlichen Aktivitäten wissen, die Ihr Unternehmen in diesem Jahr durchgeführt hat.',
                'Wenn Sie die genauen Finanzzahlen nicht kennen und nicht sammeln können, schätzen Sie bitte:'
         ],
            labels: {
                fiscalYear: "Geschäftsjahr:",
                turnover: 'Gesamtumsatz',
                capex: 'Gesamt CapEx',
                opex: 'Gesamt OpEx',
                totalActivities: 'Gesamtaktivitäten',
                cancel: 'Abbrechen',
                submit: 'Einreichen',
            },
            errorMessages: {
                yearError: 'Bitte wählen Sie ein Geschäftsjahr aus.',
                turnoverError: 'Der eingegebene Umsatzbetrag liegt unter dem aktuellen Wert des Gesamtumsatzes: {currentValue}.',
                capexError: 'Der eingegebene CapEx-Betrag liegt unter dem aktuellen Wert des Gesamt-CapEx: {currentValue}.',
                opexError: 'Der eingegebene OpEx-Betrag liegt unter dem aktuellen Wert des Gesamt-OpEx: {currentValue}.',
                activityError: 'Die eingegebene Anzahl an Aktivitäten liegt unter der Gesamtanzahl der für das ausgewählte Jahr eingereichten Aktivitäten: {currentValue}.',
            }
        },
        italian: {
            heading: "Aggiorna Fatturato Totale, CapEx, OpEx",
            paragraphs: [
                "La rendicontazione secondo la tassonomia dell'UE indica la proporzione delle attività economiche conformi alla tassonomia e allineate alla tassonomia.",
                "Per determinare il loro valore monetario, viene calcolata e riportata la quota delle attività conformi alla tassonomia e allineate alla tassonomia nel fatturato, CapEx e OpEx. Per calcolare ciò, abbiamo bisogno di sapere il tuo fatturato totale, CapEx e OpEx per l'anno fiscale che desideri valutare. Abbiamo anche bisogno di sapere il numero totale di attività economiche che la tua azienda ha svolto in quell'anno.",
                "Se non conosci e non puoi raccogliere i dati finanziari esatti, per favore stima:" ],
            labels: {
                fiscalYear: "Anno fiscale:",
                turnover: "Fatturato Totale",
                capex: "Totale CapEx",
                opex: "Totale OpEx",
                totalActivities: "Attività Totali",
                cancel: "Annulla",
                submit: "Invia"
            },
            errorMessages: {
                yearError: 'Seleziona un anno fiscale.',
                turnoverError: "L'importo del fatturato inserito è inferiore al valore attuale del Fatturato Totale: {currentValue}.",
                capexError: "L'importo del CapEx inserito è inferiore al valore attuale del CapEx Totale: {currentValue}.",
                opexError: "L'importo dell'OpEx inserito è inferiore al valore attuale dell'OpEx Totale: {currentValue}.",
                activityError: "L'importo delle attività inserito è inferiore al numero totale di attività presentate per l'anno selezionato: {currentValue}.",
            }
        },
        czech: {
            heading: "Aktualizace Celkového Obratu, CapEx, OpEx",
            paragraphs: [
                "Reporting v souladu s EU taxonomií ukazuje podíl činností splňujících a odpovídajících taxonomii.",
                "Abychom určili jejich peněžní hodnotu, vypočítáváme a vykazujeme podíl činností splňujících a odpovídajících taxonomii na obratu, investičních výdajích (CapEx) a provozních výdajích (OpEx). K tomu potřebujeme znát váš celkový obrat, CapEx a OpEx za účetní období, které chcete vyhodnotit. Také potřebujeme vědět celkový počet ekonomických činností, které vaše společnost v daném roce vykonala.",
                "Pokud neznáte a nemůžete shromáždit přesné celkové finanční údaje, prosím odhadněte:"
            ],
            labels: {
                fiscalYear: "Fiskální rok:",
                turnover: "Celkový Obrat",
                capex: "Celkový CapEx",
                opex: "Celkový OpEx",
                totalActivities: "Celkové Aktivity",
                cancel: "Zrušit",
                submit: "Odeslat"
            },
            errorMessages: {
                yearError: 'Prosím, vyberte fiskální rok.',
                turnoverError: "Zadaná částka obratu je nižší než aktuální hodnota Celkového Obratu: {currentValue}.",
                capexError: "Zadaná částka CapEx je nižší než aktuální hodnota Celkového CapEx: {currentValue}.",
                opexError: "Zadaná částka OpEx je nižší než aktuální hodnota Celkového OpEx: {currentValue}.",
                activityError: 'Zadaná částka aktivit je nižší než celkový počet aktivit odevzdaných za vybraný rok: {currentValue}.',
            }
        }
    };

    const { heading, paragraphs, labels } = content[currentLanguage];
    const { errorMessages } = content[currentLanguage];

    const getUniqueFiscalYears = () => {
        return reportYears;

        /*if (!Array.isArray(DashResult)) {
            return [];
        }

        const fiscalYears = DashResult.flatMap(value => {
            if (!Array.isArray(value?.answers)) {
                return [];
            }

            return value.answers
                .filter(answer => answer.questionType !== "Blank")
                .filter(answer => answer.questionCategory === 'Fiscal Year')
                .flatMap(answer => answer.answer || []);
        });

        return Array.from(new Set(fiscalYears)).sort((a, b) => a - b);*/
    };

    return (
        <div className='Dash-pop'>
            <section>
                <h4>{heading}</h4>
                {paragraphs.map((p, index) => <p key={index}>{p}</p>)}
                <form onSubmit={handleFormSubmit}>
                    <div>
                    <div className='d-flex align-items-center'>
                        <label className='text-start ms-3 me-3 mb-0'>{labels.fiscalYear}</label> 
                        <select className="form-select select-year" style={{height: `auto`}} onChange={(e) => setSelectedYear(e.target.value)} value={selectedYear}>
                            {reportYears.map((year, idx) => (
                                <option key={idx} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                        <div className={`input-wraps-dash ${turnover ? 'has-values' : ''}`}>
                            <input
                                type='number'
                                className='input-turnover'
                                value={turnover}
                                onChange={(e) => setTurnover(parseFloat(e.target.value) || 0)}
                            />
                            <label>{labels.turnover} <span className='text-danger'>*</span></label>
                            <div className='currency-sign'>{users.currency}</div>
                        </div>
                        <div className={`input-wraps-dash ${capex ? 'has-values' : ''}`}>
                            <input
                                type='number'
                                className='input-capex'
                                value={capex}
                                onChange={(e) => setCapex(parseFloat(e.target.value) || 0)}
                            />
                            <label>{labels.capex} <span className='text-danger'>*</span></label>
                            <div className='currency-sign'>{users.currency}</div>
                        </div>
                        <div className={`input-wraps-dash ${opex ? 'has-values' : ''}`}>
                            <input
                                type='number'
                                className='input-opex'
                                value={opex}
                                onChange={(e) => setOpex(parseFloat(e.target.value) || 0)}
                            />
                            <label>{labels.opex} <span className='text-danger'>*</span></label>
                            <div className='currency-sign'>{users.currency}</div>
                        </div>
                        <div className={`input-wraps-dash ${activity ? 'has-values' : ''}`}>
                            <input
                                type='number'
                                className='input-totalact'
                                value={activity}
                                onChange={(e) => setActivity(parseFloat(e.target.value) || 0)}
                            />
                            <label>{labels.totalActivities} <span className='text-danger'>*</span></label>
                        </div>
                    </div>
                    <div className='Dash-submit-buttons'>
                        <button type="button" onClick={GoHome} className='btn btn-secondary'>{labels.cancel}</button>
                        <button type="submit" className='btn btn-primary'>{labels.submit}</button>
                    </div>
                </form>
                <ToastContainer />
            </section>
        </div>
    );
};



const DashActivity = ({ DashResult, currentLanguage, alignedValue, notAlignedButEligibleValue, NotEligible, fiscalYear }) => {
    const translations = {
        english: {
            substantialContribution: "Substantial Contribution to Climate Change Mitigation",
            dnsh: "Do No Significant Harm",
            adaptation: "Climate change adaptation",
            water: "Sustainable use and protection of water and marine resources",
            circularEconomy: "Transition to a circular economy",
            pollution: "Pollution prevention and control",
            biodiversity: "Protection and restoration of biodiversity and ecosystems",
            activity: 'Activity',
        },
        german: {
            substantialContribution: "Wesentlicher Beitrag zum Klimaschutz",
            dnsh: "Vermeidung erheblicher Beeinträchtigungen",
            adaptation: "Anpassung an den Klimawandel",
            water: "Nachhaltige Nutzung und Schutz von Wasser- und Meeresressourcen",
            circularEconomy: "Übergang zu einer Kreislaufwirtschaft",
            pollution: "Vermeidung und Verminderung der Umweltverschmutzung",
            biodiversity: "Schutz und Wiederherstellung der Biodiversität und der Ökosysteme",
            activity: 'Aktivität',
        },
        italian: {
            substantialContribution: "Contributo Sostanziale alla Mitigazione dei Cambiamenti Climatici",
            dnsh: "Non Arrecare un Danno Significativo",
            adaptation: "Adattamento ai Cambiamenti Climatici",
            water: "Uso Sostenibile e Protezione delle Risorse Idriche e Marine",
            circularEconomy: "Transizione verso un'Economia Circolare",
            pollution: "Prevenzione e Controllo dell'Inquinamento",
            biodiversity: "Protezione e Ripristino della Biodiversità e degli Ecosistemi",
            activity: 'Attività',
        },
        czech: {
            substantialContribution: "Podstatný Příspěvek k Omezování Klimatických Změn",
            dnsh: "Nezpůsobit Významné Škody",
            adaptation: "Přizpůsobení se Klimatickým Změnám",
            water: "Udržitelné Využívání a Ochrana Vodních a Mořských Zdroje",
            circularEconomy: "Přechod na Cirkulární Ekonomiku",
            pollution: "Prevence a Kontrola Znečištění",
            biodiversity: "Ochrana a Obnova Biodiverzity a Ekosystémů",
            activity: 'Aktivita',
        }
    };

    const criteria = translations[currentLanguage];

    const updateValues = () => {
        alignedValue.length = 0;
        notAlignedButEligibleValue.length = 0;
        NotEligible.length = 0;

        const filteredResults = getFilteredDashResult(DashResult, fiscalYear);

        filteredResults.forEach((value, index) => {
            const substantialStatus = evaluateAnswers(value?.answers, 'Substantial Contribution');
            const adaptationStatus = evaluateAnswers(value?.answers, 'DNSH - Adaptation', /* categoryIsAssessable= */ false,);
            const waterStatus = evaluateAnswers(value?.answers, 'DNSH - Water');
            const ceStatus = evaluateAnswers(value?.answers, 'DNSH - Circular Economy');
            const pollutionStatus = evaluateAnswers(value?.answers, 'DNSH - Pollution');
            const biodiversityStatus = evaluateAnswers(value?.answers, 'DNSH - Biodiversity');

            const statuses = [
                substantialStatus,
                adaptationStatus,
                waterStatus,
                ceStatus,
                pollutionStatus,
                biodiversityStatus
            ];
            
            const isStatusValid = status => 
                status === EvaluationResult.CRITERIA_MET || status === EvaluationResult.NOT_ASSESSABLE;
            
            const allStatusesValid = statuses.every(isStatusValid);

            if (allStatusesValid) {
                alignedValue.push(value);
            } else {
                notAlignedButEligibleValue.push(value);
            }
        });

        return filteredResults;
    };

    useEffect(() => {
        updateValues();
    }, [fiscalYear]);

    return (
        <section>
            {updateValues().map((value, index) => {
                /*const filteredAnswers = Array.isArray(value?.answers) ? value.answers.filter(answer => answer.questionType !== "Blank") : [];
                const Turnover = filteredAnswers.filter(answer => answer.questionCategory === 'Turnover');
                const Capex = filteredAnswers.filter(answer => answer.questionCategory === 'CapEx');
                const OpEx = filteredAnswers.filter(answer => answer.questionCategory === 'OpEx');
                
                const AllTurnover = Turnover.length > 0 && Turnover.every(answer =>
                    answer.answer.every(ans => ans.trim() !== "")
                );
                const AllCapex = Capex.length > 0 && Capex.every(answer =>
                    answer.answer.every(ans => ans.trim() !== "")
                );
                const AllOpEx = OpEx.length > 0 && OpEx.every(answer =>                    
                    answer.answer.every(ans => ans.trim() !== "")
                );*/

                const substantialStatus = evaluateAnswers(value?.answers, 'Substantial Contribution');

                // Adaptation is grey if filled out because we cannot automatically check text answers
                const adaptationStatus = evaluateAnswers(value?.answers, 'DNSH - Adaptation', /* categoryIsAssessable= */ false,);
                const waterStatus = evaluateAnswers(value?.answers, 'DNSH - Water');
                const ceStatus = evaluateAnswers(value?.answers, 'DNSH - Circular Economy');
                const pollutionStatus = evaluateAnswers(value?.answers, 'DNSH - Pollution');
                const biodiversityStatus = evaluateAnswers(value?.answers, 'DNSH - Biodiversity');

                const activityName = value.examDescription ? value.examDescription : translations[currentLanguage].activity + " " + (index + 1);
                return (
                    <div key={value._id} className="card card-reports mt-5 text-start">
                        <div className="card-header">
                            <h3 className='fw-light'> {activityName}</h3>
                            <h5 className='fw-light'> {value.examName}</h5>
                        </div>
                        <div className='d-flex mx-3 mt-3 justify-content-between'>
                            <p>{criteria.substantialContribution}</p>
                            <span className={getColorForStatus(substantialStatus)}></span>
                        </div>
                        <p className="mx-3 mt-4">{criteria.dnsh}</p>
                        <div className='d-flex mx-3 mt-2 justify-content-between'>
                            <p>{criteria.adaptation}</p>
                            <span className={getColorForStatus(adaptationStatus)}></span>
                        </div>
                        <div className='d-flex mx-3 justify-content-between'>
                            <p>{criteria.water}</p>
                            <span className={getColorForStatus(waterStatus)}></span>
                        </div>
                        <div className='d-flex mx-3 justify-content-between'>
                            <p>{criteria.circularEconomy}</p>
                            <span className={getColorForStatus(ceStatus)}></span>
                        </div>
                        <div className='d-flex mx-3 justify-content-between'>
                            <p>{criteria.pollution}</p>
                            <span className={getColorForStatus(pollutionStatus)}></span>
                        </div>
                        <div className='d-flex mx-3 justify-content-between'>
                            <p>{criteria.biodiversity}</p>
                            <span className={getColorForStatus(biodiversityStatus)}></span>
                        </div>
                    </div>
                );
            })}
        </section>
    );
};
